(function ($) {
  $(document).ready(function () {
    setTimeout(function () {
      $(".tab-content-with-image").addClass("active"); }, 200);
    // On page load → set first li span text into mobile-visible
    let firstText = $(
      " .tab-content-with-image .tabs-items ul li:first-child span"
    ).text();
    $(".tab-content-with-image .tabs-items .mobile-visible").text(firstText);
    $(".tab-content-with-image .tabs-items .mobile-visible").on(
      "click",
      function () {
        $(this).siblings("ul").slideToggle();
        $(this).toggleClass("active");
      }
    );
    var $tabs = $(".tab-content-with-image .tabs-items ul li");
    // Hide all tab content except first
    $(".tab-content-with-image .tab-content").hide().first().show();
    // Ensure only the first tab is active on load
    $tabs.removeClass("active").first().addClass("active");

    // On tab click
    $(".tab-content-with-image .tabs-items ul li span").on("click", function () {
      let tabText = $(this).text();
      //On li click → update mobile-visible
      $(".tab-content-with-image .tabs-items .mobile-visible").text(tabText);

      var tabId = $(this).parent().data("tab");
      console.log(tabId);

      // Update active tab
      $(".tab-content-with-image .tabs-items ul li").removeClass("active");
      $(this).parent().addClass("active");

      // Show matching content
      $(".tab-content-with-image .tab-content").hide();
      $('.tab-content-with-image .tab-content[data-tab="' + tabId + '"]').show();
    });
    $(".tab-content-with-image .tabs-items ul li span").on("click", function () {
      if ($(window).width() < 992) {
        $(this).parents("ul").slideUp();
        $(".tabs-items .mobile-visible").removeClass("active");
      }
    });
    $(window).on("resize", function () {
      if ($(window).width() >= 992) {
        $(".tab-content-with-image .tabs-items .mobile-visible").removeClass(
          "active"
        );
        $(".tab-content-with-image .tabs-items ul ").removeAttr("style");
      }
    });

    $(window).on("load", function() {
      $(".tab-content-with-image .tab-wrapper").addClass("active");
    
      
    });
  });
})(jQuery);
